import { Label as LabelPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Label = React.forwardRef(({ className, children, ...props }, ref) => {
    return (React.createElement(LabelPrimitive, { className: cn(className), ref: ref, ...props }, children));
});
Label.displayName = "Label";
export { Label };
//# sourceMappingURL=label.js.map